import {FC} from 'react';
import {Box, Button, Grid, Typography} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import {CancelButton} from '../../common/CancelButton';
import {buttonWrapperSx, wrapperSx} from './RequestRfidFormFromDedicatedPage.sx';
import {requestRfid} from 'src/utils/consts';

export type RequestRfidFormFromDedicatedPageProps = {
    handleClose: () => void;
};

export const RequestRfidFormFromDedicatedPage: FC<RequestRfidFormFromDedicatedPageProps> = ({
                                                                                                handleClose,
                                                                                            }) => {
    const intl = useIntl();

    const openEmailClientAndClose = () => {
        window.open('mailto:info@amp-it.ch');
        handleClose();
    };

    return (
        <>
            <Grid
                sx={wrapperSx}
                container
            >
                <Grid
                    xs={12}
                    item
                >
                    <img
                        src={requestRfid}
                        alt={intl.formatMessage({id: 'requestRfid'})}
                    />

                    <Typography variant="subtitle1">
                        <FormattedMessage id="requestRfidHeader"/>
                    </Typography>

                    <Typography variant="caption">
            <span
                dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'requestRfidContent'})}}
            ></span>
                    </Typography>
                </Grid>
            </Grid>

            <Box sx={buttonWrapperSx}>
                <CancelButton
                    text="cancel"
                    handler={handleClose}
                />

                <Button
                    color="primary"
                    variant="contained"
                    onClick={openEmailClientAndClose}
                >
                    <Typography
                        variant="button"
                        color="textSecondary"
                    >
                        <FormattedMessage id="emailUs"/>
                    </Typography>
                </Button>
            </Box>
        </>
    );
};
